import { Box } from '@mui/material'
import TestIds from '../../../../../testIds'
import { AccountMenuItem } from '../../../../azure-b2c/components/AccountSwitcher'
import { DigitalFarmerAccount } from '../../../../azure-b2c/storage'
import { getAccountName } from '../../../utils/getAccountName'
import { TFOQuoteOfferScreenProps } from '../types'
import Autocomplete from '../../../../../components/Autocomplete'
import { colors } from '../../../../../themes/colors'

export interface MultiAccountSelectorProps {
  accountList: DigitalFarmerAccount[]
  farmerAccounts: DigitalFarmerAccount[]
  setAccountList: TFOQuoteOfferScreenProps['setAccountList']
}

export function MultiAccountSelector({
  accountList,
  farmerAccounts,
  setAccountList,
}: MultiAccountSelectorProps) {
  return (
    <Box>
      <Autocomplete
        slotProps={{
          popper: {
            sx: {
              zIndex: 9999,
            },
          },
        }}
        onChange={(_event, value) => {
          if (Array.isArray(value)) {
            value.filter((option) => farmerAccounts.includes(option))
            setAccountList(value as DigitalFarmerAccount[])
          }
        }}
        testId={TestIds.components.address.dairySupplyInput}
        label='Send to'
        options={farmerAccounts}
        multiple
        value={accountList}
        getOptionLabel={(option) => {
          return getAccountName(option)
        }}
        renderOption={(props, option) => (
          <Box
            component='li'
            {...props}
            key={`${option.accountNumber.toString()}-${option.accountName}`}
          >
            <AccountMenuItem bolden={false} item={option} onChange={() => null} />
          </Box>
        )}
        textFieldProps={{
          helperText: 'Select multiple accounts to send the quote to',
          helperTextColor: colors.grey700,
        }}
      />
    </Box>
  )
}
